import "@/App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "./components/AuthContext";
import Home from "./components/Home";
import Configurator from "./components/Configurator";
import Checkout, { PagoExitoso, PagoPendiente, PagoFallido } from "./components/Checkout";
import AdminDashboard from "./components/AdminDashboard";
import AdminCostPanel from "./components/AdminCostPanel";
import AdminWorkflow from "./components/AdminWorkflow";
import OrderTracking from "./components/OrderTracking";
import InvoiceRequest from "./components/InvoiceRequest";
import AdminInvoices from "./components/AdminInvoices";
import WhatsAppFloatingButton from "./components/WhatsAppButton";
import AdminLogin from "./components/AdminLogin";
import { AuthCallback, AdminProtectedRoute } from "./components/AdminAuth";
import TermsConditions from "./components/TermsConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import Contact from "./components/Contact";
import CustomerOrders from "./components/CustomerOrders";
import CustomerProfile from "./components/CustomerProfile";
import CustomerDesigns from "./components/CustomerDesigns";
import AdminDataExport from "./components/AdminDataExport";

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/configurar" element={<Configurator />} />
      <Route path="/checkout/:orderId" element={<Checkout />} />
      <Route path="/pago/exitoso" element={<PagoExitoso />} />
      <Route path="/pago/pendiente" element={<PagoPendiente />} />
      <Route path="/pago/fallido" element={<PagoFallido />} />
      <Route path="/rastreo" element={<OrderTracking />} />
      <Route path="/rastreo/:orderNumber" element={<OrderTracking />} />
      <Route path="/facturacion/:orderId" element={<InvoiceRequest />} />
      <Route path="/terminos" element={<TermsConditions />} />
      <Route path="/privacidad" element={<PrivacyPolicy />} />
      <Route path="/contacto" element={<Contact />} />
      <Route path="/mi-cuenta/pedidos" element={<CustomerOrders />} />
      <Route path="/mi-cuenta/perfil" element={<CustomerProfile />} />
      <Route path="/mi-cuenta/disenos" element={<CustomerDesigns />} />
      <Route path="/admin-login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminProtectedRoute><AdminWorkflow /></AdminProtectedRoute>} />
      <Route path="/admin/dashboard" element={<AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>} />
      <Route path="/admin/costos" element={<AdminProtectedRoute><AdminCostPanel /></AdminProtectedRoute>} />
      <Route path="/admin/facturas" element={<AdminProtectedRoute><AdminInvoices /></AdminProtectedRoute>} />
      <Route path="/admin/datos" element={<AdminProtectedRoute><AdminDataExport /></AdminProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Toaster position="top-center" />
        <div className="min-h-screen bg-background">
          <AppRouter />
          <WhatsAppFloatingButton />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
